/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Several numeric columns draw multiple lines with a legend.`)
};

const es_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varias columnas numéricas dibujan múltiples líneas con una leyenda.`)
};

const de_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere numerische Spalten zeichnen mehrere Linien mit einer Legende.`)
};

const nl_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meerdere numerieke kolommen tekenen meerdere lijnen met een legenda.`)
};

const fr_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs colonnes numériques dessinent plusieurs courbes avec une légende.`)
};

const it_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diverse colonne numeriche disegnano più linee con una legenda.`)
};

const pt_br2_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Várias colunas numéricas desenham múltiplas linhas com legenda.`)
};

const pt_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Várias colunas numéricas desenham várias linhas com uma legenda.`)
};

const ja_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の数値列があると、凡例付きの複数の線が描画されます。`)
};

const zh_line_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多列数值绘制出带图例的多条线。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_ex2", locale)
	if (locale === "en") return en_line_ex2(inputs)
	if (locale === "es") return es_line_ex2(inputs)
	if (locale === "de") return de_line_ex2(inputs)
	if (locale === "nl") return nl_line_ex2(inputs)
	if (locale === "fr") return fr_line_ex2(inputs)
	if (locale === "it") return it_line_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_line_ex2(inputs)
	if (locale === "pt") return pt_line_ex2(inputs)
	if (locale === "ja") return ja_line_ex2(inputs)
	return zh_line_ex2(inputs)
};